"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _form = _interopRequireDefault(require("./form"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Paciente = function Paciente(props) {
  return /*#__PURE__*/_react["default"].createElement(_form["default"], props);
};
Paciente.propTypes = {
  headers: _propTypes["default"].object.isRequired,
  'cpf-padrao': _propTypes["default"].string,
  campos: _propTypes["default"].object.isRequired,
  formExterno: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = Paciente;